module.exports = __webpack_public_path__ + "static/media/icons-section_80.fd970c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons-section_80.png
// module id = 476
// module chunks = 0